import React, { useEffect, useState } from "react";
import {
  ActivityContainer,
  Notification,
  NotificationContent,
  SectionTitle,
  ShowAllLink,
  ValueText,
} from "./styles";
import Typography from "../../../designComponents/Typography";
import { humanReadableDateWithTime } from "../../../utils/date";
import { useNavigate, useParams } from "react-router-dom";
import requestAPI from "../../../utils/requestAPI";
import notification from "../../../apiConfigs/notifications";
import { ReactComponent as Ellipse } from "../../../assets/Ellipse.svg";

function Notificationsection() {
  const { propertyId } = useParams();
  const [notifications, setNotifications] = useState<any[]>([]);
  const getNotifications = async () => {
    const response = await requestAPI(
      notification.getNotifications({ resourceId: propertyId })
    );
    setNotifications(response.data);
  };
  useEffect(() => {
    getNotifications();
  }, []);
  const navigate = useNavigate();
  return (
    <ActivityContainer>
      <SectionTitle style={{ fontSize: "1.25rem", marginBottom: "16px" }}>
        Activity Notifications
      </SectionTitle>
      {notifications.length > 0 ? (
        notifications.map((item, index) => (
          <Notification key={index}>
            <NotificationContent>
              <Ellipse
                fill="#F9F9FD"
                style={{
                  position: "absolute",
                  left: "-40px",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
              <div>
                <Typography size={"h5"} style={{ color: "#333" }}>
                  {item.title}
                </Typography>
                <Typography size={"h6"} style={{ color: "#333" }}>
                  {item.description}
                </Typography>
                <Typography style={{ color: "#777", fontSize: "12px" }}>
                  {humanReadableDateWithTime(item.createdAt)}
                </Typography>
              </div>
            </NotificationContent>
          </Notification>
        ))
      ) : (
        <ValueText>No activities for this property</ValueText>
      )}
      {notifications.length >= 10 && (
        <div
          onClick={() => {
            navigate(`/notifications?propertyId=${propertyId}`);
          }}
        >
          <ShowAllLink size={"h6"}>Show All Notifications</ShowAllLink>
        </div>
      )}
    </ActivityContainer>
  );
}

export default Notificationsection;
